<div class="relative block w-[34px]" [class]="{ 'hidden': !showElement }">

    <app-button
        #hyperlinkBtn
        [type]="type"
        [active]="active"
        [class]="'absolute right-0'"
        [custom]="['pill flex']"
        (click)="copyLink()"
    >
        
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
            </svg>

            @if(showLabel) {

               
                <p class="font-bold text-xs text-black ml-2 ">
                        <span>
                            {{translation.getText('copy_link', 'copy_link_text')}}
                        </span>
                </p>
     
                <button class="cursor-pointer ml-auto" (click)="forceClose(); $event.stopPropagation()">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3.5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </span>
                </button>

            }

          
    </app-button>

</div>
